import React, { PureComponent } from "react";
import { Spin, Icon } from "antd";

export default class MySpin extends PureComponent {
  render() {
    return (
      <Spin
        indicator={<Icon type="loading" style={{ fontSize: 24 }} spin />}
        tip="Loading..."
        {...this.props}
      >
        {this.props.children}
      </Spin>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Spin.js